import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import Window from "../2/Controls/Window";
import AddEditFeedbackLink from "./AddEditFeedbackLink";

class FeedbacksList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      list: [],
      totalCount: 0,
      loading: false,
      page: 1,
      pageSize: 25,
      searchText: "", 
      listData: [],
      deleting: false,
      selectedRow: null,
      showDelete: false,
      showAddFeedbackLink: false,
      showGeneratedLink: false, // New state for showing generated link
      generatedLink: "", // New state for storing generated link
      listPageSettings: {
        Title: "Feedback",
        Search: {
          showSearch: false,
          placeholder: "Search by feedback title",
          onSearch: this.onSearch,
          onRefresh: this.onRefreshClick,
        },
        HeaderButtons: [
            {
            ButtonType: "ImageButton",
            Type: "refresh",
            Text: "refresh",
            Icon: "refresh",
            Action: "refresh",
            showInCompact: true,
          },
          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          },
           
        ],
        Columns: [
          {
            Name: "Link",
            Type: "link",
            Column: "Link"
          },
           {
            Name: "Template",
             Type: "field",
            Columns: [{ Column: "FormTitle" }]
          },
          {
            Name: "ValidityFrom",
            Type: "field",
            Columns: [{ Column: "ValidityFrom" }]
          },
          {
            Name: "ValidityTo",
            Type: "field",
            Columns: [{ Column: "ValidityTo" }]
          },
            {
            Name: "Response",
            Type: "field",
            Columns: [{ Column: "ResponseCount" }]
          }
        ],
        RowButtons: [
           { ButtonType: "ImageButton", Type: "view", Text: "view", Icon: "view", Action: "view" },
          { ButtonType: "ImageButton", Type: "edit", Text: "Edit", Icon: "edit", Action: "edit" },
          // { ButtonType: "ImageButton", Type: "delete", Text: "Delete", Icon: "delete", Action: "delete" }
        ],
      },
      copyButtonText: "Copy",
    };
    
    // Bind the copy method
   this.copyToClipboard = this.copyToClipboard.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  onRowButtonClicked = (btn, row) => {
     
       if (btn.Action === "view") {
         this.props.history.push({
                        pathname:"/home/feedbacks/response",
                        state: { data: row }
                      });
    }
    if (btn.Action === "edit") {
      this.setState({
        showAddFeedbackLink: true,
        selectedRow: row
      });
    }

    if (btn.Action === "delete") {
      this.setState({
        showDelete: true,
        selectedRow: row
      });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageSize !== this.state.pageSize
    ) {
      this.loadData();
    }
  }

  // ======================
  // LOAD DATA
  // ======================

  loadData = async () => {
    this.setState({ loading: true });
    const { searchText } = this.state;

    try {

      let response = await this.props.getFeedbackLinks(this.props.config.WhiteLabel.Code);
      let list = [];
      
      if (response.code === "0") {
        list = response.data;
      } else {
        alert("Failed to fetch feedback");
        list = [];
      }

      this.setState({
        list: list || [],
        totalCount: list ? list.length : 0,
        loading: false
      });
    } catch (error) {
      console.log(error);
      this.setState({ 
        loading: false,
        list: [],
        totalCount: 0
      });
    }
  };

  // ======================
  // PAGINATION
  // ======================

  onNextClick = () => {
    const totalPages = Math.ceil(this.state.totalCount / this.state.pageSize);
    if (this.state.page < totalPages) {
      this.setState({ page: this.state.page + 1 });
    }
  };

  onPreviousClick = () => {
    if (this.state.page > 1) {
      this.setState({ page: this.state.page - 1 });
    }
  };

  onFirstClick = () => this.setState({ page: 1 });

  onLastClick = () => {
    const totalPages = Math.ceil(this.state.totalCount / this.state.pageSize);
    this.setState({ page: totalPages });
  };

  onRecordsPerPageCountChange = (size) => {
    this.setState({
      pageSize: Number(size),
      page: 1
    });
  };

  // ======================
  // HEADER BUTTONS
  // ======================

  onHeaderButtonClicked = (btn) => {
    if (btn.Action === "new") {
      this.setState({
        showAddFeedbackLink: true,
        selectedRow: {}
      });
    }
    if(btn.Action==="refresh"){
      this.onRefreshClick();
    }
  };

  // ======================
  // SEARCH
  // ======================

  onSearch = (searchText) => {
    this.setState({ searchText }, () => {
      this.loadData();
    });
  };

  onRefreshClick = () => {
    this.loadData();
  };

  onPageChange = (page, pageSize) => {
    console.log("page", page);
    this.setState(
      { page, pageSize },
      () => {
        this.loadData();
      }
    );
  };

  deleteRecord = async () => {
    try {
      this.setState({
        deleting: true
      });
      const response = await this.props.deleteFeedbackLink(this.state.selectedRow.key);
      if (response.code === "0") {
        alert("feedback template delete successfully");
      } else {
        alert("failed to delete feedback template");
      }
      this.setState({
        deleting: false,
        showDelete: false,
        selectedRow: null
      }, this.loadData);
    } catch (error) {
      alert("failed to delete feedback template");
      this.setState({
        deleting: false,
        showDelete: false,
        selectedRow: null
      }, this.loadData);
    }
  };

  // ======================
  // COPY TO CLIPBOARD
  // ======================

 copyToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(this.state.generatedLink);
    this.setState({ copyButtonText: "Copied!" });
    
    // Reset after 3 seconds
    setTimeout(() => {
      this.setState({ copyButtonText: "Copy" });
    }, 3000);
  } catch (err) {
    // Fallback method for older browsers
    const textArea = document.createElement("textarea");
    textArea.value = this.state.generatedLink;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    this.setState({ copyButtonText: "Copied!" });
    
    // Reset after 3 seconds
    setTimeout(() => {
      this.setState({ copyButtonText: "Copy" });
    }, 3000);
  }
}

  // ======================
  // HANDLE GENERATED LINK
  // ======================

  handleLinkGenerated = (link) => {
  this.setState({
    generatedLink: link,
    showGeneratedLink: true,
    copyButtonText: "Copy" // Reset button text when new link is generated
  });
}

  render() {
    return (
      <>
        <ListingPage
          {...this.props}
          onPageChange={this.onPageChange}
          listPageSettings={this.state.listPageSettings}
          list={this.state.list}
          loading={this.state.loading}
          totalItemsCount={this.state.totalCount}
          recordFrom={(this.state.page - 1) * this.state.pageSize}
          itemsCountPerPage={this.state.pageSize}
          onNextClick={this.onNextClick}
          onPreviousClick={this.onPreviousClick}
          onFirstClick={this.onFirstClick}
          onLastClick={this.onLastClick}
          onRecordsPerPageCountChange={this.onRecordsPerPageCountChange}
          onHeaderButtonClicked={this.onHeaderButtonClicked}
          onRowButtonClicked={this.onRowButtonClicked}
        />

        {/* Delete Confirmation Window */}
        {this.state.showDelete && (
          <Window
            header={"Delete"}
            size="medium"
            modal={true}
            processing={this.state.deleting}
            onClose={() =>
              this.setState({
                showDelete: false
              })
            }
            onButtonClick={(buttonType) => {
              if (buttonType.toLowerCase() === "yes") {
                this.deleteRecord();
              } else {
                this.setState({
                  showDelete: false,
                  selectedRow: null
                });
              }
            }}
            buttons={[
              {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              },
            ]}
          >
            <div>
              Are you sure you wish to delete this record?
            </div>
          </Window>
        )}

        {/* Add/Edit Feedback Link Window */}
        {this.state.showAddFeedbackLink && (
          <AddEditFeedbackLink
            {...this.props}
            editData={this.state.selectedRow}
            onSave={() => {
              this.loadData();
              this.setState({ selectedRow: {}, showAddFeedbackLink: false });
            }}
            onClose={() => {
              this.loadData();
              this.setState({ selectedRow: {}, showAddFeedbackLink: false });
            }}
            onLinkGenerated={this.handleLinkGenerated}
          />
        )}

        {/* Generated Link Window */}
      {/* Generated Link Window */}
{this.state.showGeneratedLink && (
  <Window
    header={"Feedback Link Generated"}
    size="medium"
    modal={true}
    processing={false}
    onClose={() =>
      this.setState({
        showGeneratedLink: false,
        generatedLink: "",
        copyButtonText: "Copy" // Reset when closing
      })
    }
  >
    <div style={{ padding: "20px" }}>
      <div style={{ 
        display: "flex",
        alignItems: "center",
        gap: "10px",
        border: "1px solid #ddd",
        borderRadius: "4px",
        padding: "4px",
        backgroundColor: "#f5f5f5"
      }}>
        <input
          type="text"
          value={this.state.generatedLink}
          readOnly
          style={{
            flex: 1,
            border: "none",
            outline: "none",
            padding: "8px 12px",
            fontSize: "14px",
            backgroundColor: "transparent",
            color: "#0066cc",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap"
          }}
          title={this.state.generatedLink}
        />
        <button
          onClick={this.copyToClipboard}
          style={{
            padding: "6px 16px",
            backgroundColor: this.state.copyButtonText === "Copied!" ? "#28a745" : "#065fd4",
            color: "white",
            border: "none",
            borderRadius: "2px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
            whiteSpace: "nowrap",
            flexShrink: 0,
            transition: "background-color 0.3s ease"
          }}
          onMouseEnter={(e) => {
            if (this.state.copyButtonText !== "Copied!") {
              e.target.style.backgroundColor = "#0353a4";
            }
          }}
          onMouseLeave={(e) => {
            if (this.state.copyButtonText !== "Copied!") {
              e.target.style.backgroundColor = "#065fd4";
            }
          }}
        >
          {this.state.copyButtonText || "Copy"}
        </button>
      </div>
    </div>
  </Window>
)}
      </>
    );
  }
}

export default FeedbacksList;